import React from "react";
import Image6 from "../../../images/Image6.png";
import Image2 from "../../../images/Image2.jpg";
import Image5 from "../../../images/Image5.jpg";
import Image4 from "../../../images/Image4.jpeg";
import PageLayout from "../../ui/PageLayout";
import PageHero from "../../ui/PageHero";
import SplitStorySection from "../../ui/SplitStorySection";
import CategoryCardGrid from "../../ui/CategoryCardGrid";
import FadeIn from "../../ui/FadeIn";

// const ongoingCards = [
  
// ];

const pastCards = [
  { to: "./plantkindness", image: Image2, title: "Project Plant Kindness 2.0" },
  { to: "./nashta", image: Image5, title: "Project Nashta" },
  { to: "./cupofkindness", image: Image4, title: "Cup Of Kindness" },
  { to: "./fooddistribution", image: Image6, title: "Food Distribution" },
  { to: "./gobananas", image: Image5, title: "Go Bananas" },
];

const ComNutrition = () => (
  <PageLayout>
    <PageHero title="KU for Community & Nutrition" light />
    <SplitStorySection image={Image6} imageAlt="Community and Nutrition">
      <p>
        What can a man do with a shirt on his back & a roof on his head, but without a morsel in his stomach?
      </p>
      <p>
        Nothing... nothing at all, but lose his life; perhaps to a slow & bitter death! <br />
        According to the &apos;State of Food Security and Nutrition in the World&apos;, 2020 report; 14% of the Indian population suffer from undernourishment. Worse still, children constitute a major part of this percentage!
      </p>
      <p>
        Therefore, in its pursuit to abolish hunger from in & around the state of Maharashtra, KU initiated kindness engagements such as Cup Of Kindness, Go Bananas & Project Nashta, to name a few.
      </p>
      <p>
        These projects are categorised under the banner of &apos;KU for Community & Nutrition&apos; and are in sync with the UN&apos;s goal of Zero Hunger and Good Health & Wellbeing.
      </p>
      <p>
        Read on to know the ins & outs of what goes into making each of these kindness engagements impactful, memorable & a success.
      </p>
    </SplitStorySection>
    {/* <section className="ku-section bg-ku-cream">
      <div className="ku-container">
        <FadeIn>
          <h3 className="ku-heading-md text-ku-royal mb-3">Ongoing Projects</h3>
          <div className="w-16 h-1 bg-ku-gold rounded-full mb-8" />
        </FadeIn>
        <CategoryCardGrid cards={ongoingCards} columns={2} bare />
      </div>
    </section> */}
    <section className="ku-section bg-white pt-0">
      <div className="ku-container">
        <FadeIn>
          <h3 className="ku-heading-md text-ku-royal mb-3">Past Projects</h3>
          <div className="w-16 h-1 bg-ku-gold rounded-full mb-8" />
        </FadeIn>
        <CategoryCardGrid cards={pastCards} columns={3} bare />
      </div>
    </section>
  </PageLayout>
);

export default ComNutrition;
